// extracted by mini-css-extract-plugin
export default {"allTypesPageTable":"all-types-page_allTypesPageTable__NPlHG"};